import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { PageTransition } from "./PageTransition";
import { SkipNavigation } from "./SkipNavigation";
import { HeaderThemeProvider } from "./HeaderThemeContext";
import { CookieConsent } from "@/components/cookies/CookieConsent";
import { WhatsAppFloat } from "./WhatsAppFloat";
import { StickyMobileCTA } from "./StickyMobileCTA";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <HeaderThemeProvider>
      <div className="flex min-h-screen flex-col">
        <SkipNavigation />
        <Header />
        <main id="main-content" className="flex-1 pt-18">
          <PageTransition>
            {children}
          </PageTransition>
        </main>
        <Footer />
        <CookieConsent />
        <WhatsAppFloat />
        <StickyMobileCTA />
      </div>
    </HeaderThemeProvider>
  );
}
